import { render, staticRenderFns } from "./ServiceFooter.vue?vue&type=template&id=38ea8591&scoped=true&"
import script from "./ServiceFooter.vue?vue&type=script&lang=js&"
export * from "./ServiceFooter.vue?vue&type=script&lang=js&"
import style0 from "./ServiceFooter.vue?vue&type=style&index=0&id=38ea8591&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ea8591",
  null
  
)

export default component.exports